/**
 * This brings event dom node with id: eventId into viewport and focuses it
 * @param eventId
 */
export default eventId => {
  const elem = document.querySelector(`#event-${eventId}`)
  elem?.scrollIntoView()
  setTimeout(() => elem?.querySelector('.selector').focus(), 100)
}
